export default __webpack_public_path__ + "static/media/Kheshatta.cfa9265c.jpg";